/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { contactSalesControllerCreate } from "./contactSalesControllerCreate";

export function contactSalesService() {
  return { contactSalesControllerCreate }
}